// extracted by mini-css-extract-plugin
module.exports = {"option":"searchResultDropdown_option__qZlbU","optionText":"searchResultDropdown_optionText__O84Gj"};